export interface ApiImage {
    data: DataImageDetails[];
}

export interface DataImageDetails {
    attributes: {
        uri: string;
        height: number;
        width: number;
    };

    id: string;
    links: { self: string };
    type: string;
}

export type ListImage = string | LocalImg;

export interface LocalImg {
    userImage: string | ArrayBuffer | null;
    name: string;
}

export function isLocalImg(type: any): type is LocalImg {
    return type.userImage !== undefined;
}
